import React, { useState } from "react";
import "./ReferencesSection.css";
import { useTranslation } from "react-i18next";
import { getReferences } from "./api";
import { useQuery } from "@tanstack/react-query";
import fallbackImg from "../../../../../assets/images/fallback.png";

function ReferencesSection() {
  const { i18n } = useTranslation("home");

  const { data, isLoading } = useQuery({
    queryKey: ["references"],
    queryFn: getReferences,
  });
  console.log(i18n.language.toLocaleLowerCase());
  if (isLoading) return <p>Loading...</p>;

  return (
    <section className="references-page-section">
      <div className="container news-section-container">
        {data?.map((item) => (
          <div className="references-card">
            <picture>
              <img src={item.image_url || fallbackImg} alt="" />
            </picture>
            <div className="references-card-content">
              <h6>{item.title?.[i18n.language.toLocaleLowerCase()]}</h6>
              <p className="small">
                {item.description?.[i18n.language.toLocaleLowerCase()]}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ReferencesSection;
